<script setup lang="ts">
import ApostatudoGames from '~/components/casino/games/ApostatudoGames.vue';
import { scrollToTop } from '~/utils/scroll';

const { isDesktop } = useLayout();

onMounted(() => {
  if (isDesktop.value) return;

  requestAnimationFrame(() => {
    const el = document.getElementById('divMenuHighlight');

    if (!el) return;

    scrollToTop(el.offsetHeight);
  });
});
</script>

<template>
  <ApostatudoGames />
</template>
